import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Rating,
  Box,
  Chip,
  TextField,
  InputAdornment,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const Vendors = () => {
  const [vendors, setVendors] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchVendors();
  }, []);

  const fetchVendors = async () => {
    try {
      const response = await axios.get(`${API_URL}/vendors`);
      setVendors(response.data.vendors || []);
    } catch (error) {
      console.error('Error fetching vendors:', error);
    }
  };

  const filteredVendors = vendors.filter((vendor) =>
    vendor.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Container sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Service Providers
      </Typography>

      <TextField
        fullWidth
        placeholder="Search vendors..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{ mb: 3 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />

      {filteredVendors.length === 0 ? (
        <Typography>No vendors found</Typography>
      ) : (
        <Grid container spacing={3}>
          {filteredVendors.map((vendor) => (
            <Grid item xs={12} sm={6} md={4} key={vendor.id}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {vendor.name}
                  </Typography>
                  <Box display="flex" alignItems="center" mb={1}>
                    <Rating value={parseFloat(vendor.avg_rating) || 0} readOnly size="small" />
                    <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                      ({vendor.review_count || 0} reviews)
                    </Typography>
                  </Box>
                  {vendor.service_types && (
                    <Box mb={1}>
                      {(Array.isArray(vendor.service_types) ? vendor.service_types : 
                        typeof vendor.service_types === 'string' ? 
                          (() => { try { return JSON.parse(vendor.service_types); } catch { return []; } })() : 
                          []).map((type, index) => (
                        <Chip key={index} label={type} size="small" sx={{ mr: 0.5, mb: 0.5 }} />
                      ))}
                    </Box>
                  )}
                  {vendor.description && (
                    <Typography variant="body2" color="text.secondary">
                      {vendor.description}
                    </Typography>
                  )}
                  {vendor.phone && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      Phone: {vendor.phone}
                    </Typography>
                  )}
                </CardContent>
                <CardActions>
                  <Button size="small" onClick={() => window.location.href = `/vendors/${vendor.id}`}>
                    View Details
                  </Button>
                  <Button size="small" variant="contained">
                    Book Service
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default Vendors;

